function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512px",
  viewBox: "0 0 512 512",
  width: "512px",
  className: ""
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0",
  fill: "#607d8b",
  "data-original": "#607D8B",
  className: "",
  style: {
    "fill": "#528AEA"
  },
  "data-old_color": "#607d8b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m368 277.332031h-224c-11.777344 0-21.332031-9.554687-21.332031-21.332031s9.554687-21.332031 21.332031-21.332031h224c11.777344 0 21.332031 9.554687 21.332031 21.332031s-9.554687 21.332031-21.332031 21.332031zm0 0",
  fill: "#fafafa",
  "data-original": "#FAFAFA",
  className: "active-path",
  style: {
    "fill": "#FAFAFA"
  }
})));
export default __webpack_public_path__ + "teg/media/theme-minus.b9c35ec8.svg";
export { SvgComponent as ReactComponent };